export const SORTING_OPTION_VALUES = {
  LATEST_FIRST: "-creationtime",
  OLDEST_FIRST: "creationtime",
  ALPHABETICAL_AZ: "deviceid",
  ALPHABETICAL_ZA: "-deviceid",
};

export const SORTING_OPTIONS = [
  {
    label: "Latest First",
    value: SORTING_OPTION_VALUES.LATEST_FIRST,
  },
  {
    label: "Oldest First",
    value: SORTING_OPTION_VALUES.OLDEST_FIRST,
  },
  {
    label: "Alphabetical (A-Z)",
    value: SORTING_OPTION_VALUES.ALPHABETICAL_AZ,
  },
  {
    label: "Alphabetical (Z-A)",
    value: SORTING_OPTION_VALUES.ALPHABETICAL_ZA,
  }
];

export const VEHICLE_MAP_SORTING_OPTIONS = [
  {
    label: "Latest First",
    value: "desc",
  },
  {
    label: "Oldest First",
    value: "asc",
  },
];